import { render, staticRenderFns } from "./incomeBusiness.vue?vue&type=template&id=b3601c60"
import script from "./incomeBusiness.vue?vue&type=script&lang=js"
export * from "./incomeBusiness.vue?vue&type=script&lang=js"
import style0 from "./incomeBusiness.vue?vue&type=style&index=0&id=b3601c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports